import { render, staticRenderFns } from "./comunidad-form.vue?vue&type=template&id=4d469ed5&scoped=true"
import script from "./comunidad-form.vue?vue&type=script&lang=js"
export * from "./comunidad-form.vue?vue&type=script&lang=js"
import style0 from "./comunidad-form.vue?vue&type=style&index=0&id=4d469ed5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d469ed5",
  null
  
)

export default component.exports